import heroSectionStyles from './HeroSection.module.css';
import HeroHeader from '../../components/HeroHeader/HeroHeader';
import ContactDropdown from '../../components/ContactDropdown/ContactDropdown';
import AvailabilityDropdown from '../../components/AvailabilityDropdown/AvailabilityDropdown';

const HeroSection = () => (
  <>
  <HeroHeader/>
  <section className={heroSectionStyles.heroSection}
  style={{ backgroundImage: 'url("/images/iStock-907888472.jpg")'}}
  >
    <div className={heroSectionStyles.overlay}>
      <h1 className={heroSectionStyles.title}>Welcome to 377 Storage</h1>
      <p className={heroSectionStyles.subtitle}>
        Storage You Can Trust — In The Heart of Collinsville Texas
      </p>
      <div className={heroSectionStyles.buttonGroup}>
      {/*<AvailabilityDropdown></AvailabilityDropdown>*/}
      <ContactDropdown></ContactDropdown>
      </div>
    </div>
  </section>
  </>
);

export default HeroSection;
